<template>
  <div class="item-wrapper">
    <sm-event
      v-if="isScrollMagic && isLastItem"
      triggerHook="0"
      @onEnter="onEnter"
      @onLeave="onLeave"
      :offset="0"
      durationType="element"
    ></sm-event>
    <sm-event
      v-if="isScrollMagic && isAnimation"
      triggerHook="1"
      @onEnter="onFrontAnimeEnter"
      :offset="0"
      durationType="element"
    ></sm-event>
    <router-link v-if="!disabled" :class="{'trans-slideup': isAnimation}" :to="{ path: '/products/' + data.id }">
      <sm-event
        v-if="isLarge"
        triggerHook="0.3"
        @onEnter="onTitleEnter"
        @onLeave="onTitleLeave"
        :offset="0"
        durationType="element"
      ></sm-event>
      <div class="c-product-card" :class="{dark: data.primaryColor === 'ブラック'}">
        <h3 v-html="title"></h3>
        <div class="p-wrap"><p v-html="updateNewline(data.workexcerpt, lineBreak)"></p></div>
      </div>
      <div class="c-product-wrap">
        <div
          class="c-product-image pointer-target"
          :style="{ backgroundImage: 'url(' + data.workeimage + ')' }"
        ></div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    data: Object,
    isScrollMagic: {
      type: Boolean,
      default: false
    },
    lineBreak: String,
    isLastItem: Boolean,
    isAnimation: Boolean,
    isLarge: Boolean,
    disabled: Boolean
  },
  data () {
    return {
      title: ''
    }
  },
  mounted () {
    this.updateTitle()
  },
  methods: {
    updateTitle () {
      // console.log('>>> ', typeof this.data.worktitle, this.data.worktitle)
      // console.log('>>> ', this.data.worktitle.match(/[\/@]/g))
      let title = ''
      if (this.lineBreak === '<br />' && this.data.worktitle.match(/[/|@]/g) !== null) {
        console.log(this.$store.state.currentMq)
        if (this.$store.state.currentMq === 'query-sm') {
          title = this.data.worktitle.replace(/[@]/g, ' ')
        } else {
          title = this.data.worktitle.replace(/[/@]/g, '<br />')
        }
      } else {
        title = this.data.worktitle
      }
      this.title = title
    },
    updateNewline (data, alt) {
      return data.replace(/[\n]/g, alt)
    },
    updateSlash (data, alt) {
      if (alt === '<br />') {
        return data.replace(' / ', '<br />')
      } else {
        return data
      }
    },
    onEnter (event) {
      if (event.scrollDirection === 'FORWARD') {
        this.$emit('parentOnEnter', event.currentTarget.triggerElement())
      }
    },
    onLeave (event) {
      if (event.scrollDirection === 'REVERSE') {
        this.$emit('parentOnLeave', event.currentTarget.triggerElement())
      }
    },
    onTitleEnter (event) {
      event.currentTarget.triggerElement().nextElementSibling.classList.add('hide')
    },
    onTitleLeave (event) {
      event.currentTarget.triggerElement().nextElementSibling.classList.remove('hide')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProductItem.vue